import React from 'react';
import styles from './index.scss';

import { Button, Flex } from 'design-system-web';
import { H5 } from 'components/typography';
import { Channel } from 'lane-shared/types/ChannelType';
import { useTranslation } from 'react-i18next';
import { ChannelListItem } from '../../../../components/ChannelListItem';
import { useOnboardingAnalytics } from 'lane-shared/hooks/analytics';
import { OnboardingCompleteData } from '../..';

const TRANSLATION_KEYS = {
  yesButton: 'shared.common.yes',
  otherCompanyButton: 'shared.onboarding.company.otherCompanyButton',
  preselectedPlaceholder: 'shared.onboarding.company.preselectedPlaceholder',
};

type Props = {
  userName: string;
  building: Channel | null;
  isLoading: boolean;
  preselectedCompany: Channel;
  onComplete: (data: OnboardingCompleteData) => void;
  handlers: {
    handleOtherCompanyClick: () => void;
  };
};

export function OnboardingPreselectedCompany({
  userName,
  building,
  isLoading,
  preselectedCompany,
  onComplete,
  handlers,
}: Props) {
  const { t } = useTranslation();
  const { onboardingTracker } = useOnboardingAnalytics();

  const onSubmit = () => {
    onboardingTracker.Select.Company({ companyId: preselectedCompany._id });

    if (building) {
      onComplete({
        company: preselectedCompany,
        building,
        userName,
      });
    }
  };

  return (
    <div className={styles.container}>
      <H5>{t(TRANSLATION_KEYS.preselectedPlaceholder)}</H5>
      <Flex align="center" className={styles.selectedChannelContainer}>
        <ChannelListItem
          className={styles.preselectedChannel}
          showName
          showCompanyIcon
          channel={preselectedCompany}
          onClick={() => {}}
        />
      </Flex>
      <Button
        className={styles.button}
        fullWidth
        onClick={onSubmit}
        size="large"
        type="submit"
        disabled={!building?._id}
        loading={isLoading}
      >
        {t(TRANSLATION_KEYS.yesButton)}
      </Button>
      <Button
        className={styles.button}
        fullWidth
        onClick={handlers.handleOtherCompanyClick}
        size="large"
        variant="secondary"
        loading={isLoading}
      >
        {t(TRANSLATION_KEYS.otherCompanyButton)}
      </Button>
    </div>
  );
}
